class ProfilePopupContainer {
  constructor() {
    this.portal = document.createElement('div');
    this.portal.id = 'portal-container';
    document.body.appendChild(this.portal);
  }

  clear() {
    this.portal.innerHTML = '';
  }
}

export default {
  install: function(Vue, options) {
    Vue.prototype.profilePopupContainer = new ProfilePopupContainer();
  },
};
